module.exports = __webpack_public_path__ + "img/2.3b211038.png";